// scroll-to-blog.js
// Automatischer Scroll zur Blogartikel-Sektion bei Tag-Filtern auf Blogseiten

document.addEventListener("DOMContentLoaded", function () {
  const isBlogTagPage =
    window.location.pathname.includes("/blogs/") &&
    window.location.pathname.includes("/tagged/");

  if (isBlogTagPage) {
    const target = document.getElementById("blog-article-section");
    if (target) {
      // Scrollt sanft zur Blogartikel-Sektion
      target.scrollIntoView({ behavior: "smooth" });
    }
  }
});
